import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

let list = [
    {
        img: '/images/pic/gge/complex1.png',
        title: '01. Проблема репликации и&nbsp;синхронизации серверов',
        subtitle:
            'Ресурс gge.ru состоит из&nbsp;4&nbsp;серверов, которые друг с&nbsp;другом взаимодействуют. Зачастую случайным образом выбирается какой-то из&nbsp;серверов, к&nbsp;которому обращается пользователь. Информация, которая будет передаваться пользователю с&nbsp;этого сервера не&nbsp;всегда будет соответствовать информации на&nbsp;других серверах. В&nbsp;результате разные пользователи будут видеть разные данные. Чтобы устранить сбой репликации, сняли последний бэкап дампа с&nbsp;мастера и&nbsp;залили на&nbsp;подчиненный сервер. Там перезапустили репликацию. Перевели lsyncd в&nbsp;демон и&nbsp;настроили контроль pid процесса.',
        reverse: false,
    },
    {
        img: '/images/pic/gge/complex2.png',
        title: '02. Подтверждение гипотезы',
        subtitle:
            'Папка с&nbsp;историей (.git) начала быстро разрастаться. Вес папки составлял 575,7&nbsp;МБ. Это большой объем, который влечет за&nbsp;собой трудности в&nbsp;работе с&nbsp;сайтом. Например, долгий отклик на&nbsp;просмотр истории (около 7-10&nbsp;секунд), длительное время скачивания репозитория, деплой и&nbsp;применения изменений. Под Git было добавлено ядро системы (папка bitrix). Эти файлы не&nbsp;должны отслеживаться git, в&nbsp;них нельзя вносить изменения. Ядро постоянно модифицируется и&nbsp;фиксируется системой контроля версий, что вызывает проблему разрастания истории. Наше решение состоит из&nbsp;2-х этапов: удаление папки bitrix из-под отслеживания и&nbsp;очистка истории.',
        reverse: true,
    },
];

const Complex = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper className="gge-complex">
                <CommonTitle>Сложности</CommonTitle>

                <CommonUsualText className="gge-complex__title">
                    В&nbsp;процессе решения задач мы&nbsp;столкнулись с&nbsp;несколькими сложностями
                </CommonUsualText>

                <div className="gge-complex__container">
                    {list.map(({ img, title, subtitle, reverse }, index) => (
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className={
                                reverse
                                    ? 'gge-complex__item gge-complex__item--reverse'
                                    : 'gge-complex__item'
                            }
                            key={index}
                        >
                            <div className="gge-complex__item-img">
                                <img src={img} alt="" loading="lazy" />
                            </div>
                            <div className="gge-complex__item-info">
                                <CommonSmallTitle className="gge-complex__item-title">
                                    {parse(title)}
                                </CommonSmallTitle>
                                <CommonSmallText className="gge-complex__item-text">
                                    {parse(subtitle)}
                                </CommonSmallText>
                            </div>
                        </ScrollAnimation>
                    ))}
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
